export default __webpack_public_path__ + "static/media/22649878-2F2F-4C53-92A5-3A203B8D8C4A_1_105_c.44fdcfac.jpeg";